import { useQuery } from "@tanstack/react-query";

export type MessagingOutageStatus = {
  /** True only when the admin outage toggle is confirmed ON. */
  enabled: boolean;
  /** True while the first fetch is in flight (callers should fail-open). */
  isLoading: boolean;
};

/**
 * Reads the admin-managed global messaging-outage toggle. FAIL-OPEN by design:
 * while the query is loading or if it errors, `enabled` stays `false` so a
 * transient read failure never hides every host's compose box. Only a confirmed
 * `{ enabled: true }` response swaps the composer for the outage banner.
 */
export function useMessagingOutage(): MessagingOutageStatus {
  const query = useQuery<{ enabled: boolean }>({
    queryKey: ["/api/app/messaging-outage"],
    queryFn: async () => {
      const res = await fetch("/api/app/messaging-outage", { credentials: "include" });
      if (!res.ok) throw new Error("Failed to load messaging outage status");
      return res.json();
    },
    staleTime: 60 * 1000,
    refetchInterval: 60 * 1000,
  });

  return {
    enabled: query.data?.enabled === true,
    isLoading: query.isLoading,
  };
}
